export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Crypto ID:"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Тіл"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Қайырлы таң"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Қайырлы күн"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Қайырлы кеш"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Қайырлы түн"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Шығу"])}
}